import React from 'react'
import {Container, Row, Col} from 'react-bootstrap'
import {Link} from 'react-router-dom'
import Icons from 'json/icons'

export default function footer() {
    return (
        <div className="footer">
            <Container>
                <Row className="footer-container">
                    <Col md={4}>
                        <div className="content-footer">
                            <h6>Malmora.</h6>
                            <p>Jln. Abdullah Dg. Sirua No. XX, Kec. Manggala, Kota Makassar, Sulawesi Selatan, 90234.</p>
                            <div className="content-icons">
                                {
                                    Icons.map((data, i) => {
                                        return (
                                            <Link to="#" key={i}> <img src={`asset/home/icons/${data.image}.svg`} alt={data.alt} /> </Link> 
                                        )
                                    })
                                }                          
                            </div>
                        </div>
                    </Col>
                    <Col md={2}>
                        <div className="cards-footer">
                            <ul>
                               <div className="judul-footer">Get Started</div>
                                <li>Daftar</li>
                                <li>Kantor Utama</li>
                                <li>Jadi Supplier</li>
                            </ul>
                        </div>
                    </Col>
                    <Col md={2}>
                        <div className="artikel-footer">
                            <ul>
                                 <div className="judul-footer">About Us</div>
                                <li>Artikel</li>
                                <li>Tentang</li>
                                <li>Karir</li>
                            </ul> 
                        </div>
                    </Col>
                    <Col md={2}>
                        <div className="unduh-footer">
                            <ul>
                                 <div className="judul-footer">About Us</div>
                                <li>Artikel</li>
                                <li>Tentang</li>
                                <li>Karir</li>
                            </ul> 
                        </div>
                    </Col>
                    <Col md={2}>
                    <div className="unduh-footer">
                           <li>Download Aplikasi</li> 
                            <li><img src="asset/home/icons/google-play.svg" alt="download" /></li> 
                    </div>
                </Col>
                </Row>
            </Container>
            <div className="footer-link">
                <Link to="#">Syarat dan Ketentuan</Link>
                <Link to="#">Kebijakan Privasi</Link>
            </div>
        </div>
    )
}
